import { editStyle } from './safeZoneHelper.ts'
import { SafeZonePolygon } from '../mapComponents/SafeZonePolygon.tsx'
import { ref } from 'valtio'
import { safeZoneState, setNewSafeZone } from '../../../store/safeZoneState.ts'

export function drawSafeZone(map: google.maps.Map) {
    const drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYLINE,
        drawingControl: false,
        polygonOptions: {
            ...editStyle,
            editable: true,
            zIndex: 1,
        },
        polylineOptions: {
            ...editStyle,
            editable: true,
            zIndex: 1,
        },
    })
    safeZoneState.drawingManager = ref(drawingManager)
    window.google.maps.event.addListener(drawingManager, 'overlaycomplete', (event: any) => {
        if (event.type === google.maps.drawing.OverlayType.POLYLINE) {
            if (!safeZoneState.drawingManager?.getDrawingMode()) {
                return
            }
            const coords = event.overlay.getPath().getArray().map((p: any) => {
                return {lat: p.lat(), lng: p.lng()}
            })
            drawingManager.setDrawingMode(null)
            safeZoneState.drawingManager = null
            event.overlay.setMap(null)
            const poly = <SafeZonePolygon isNew={true} coords={coords} options={editStyle}/>
            safeZoneState.newSafeZoneGeometry = coords
            setNewSafeZone(poly)
            safeZoneState.view = 'finish'
        }
    })
    drawingManager.setMap(map)
    return drawingManager
}
